import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: [],
  reducers: {
    adminAdded(state, action) {
      return action.payload;
    },
  },
});

export const { adminAdded } = adminSlice.actions;
export default adminSlice.reducer;
